// extracted by mini-css-extract-plugin
export var contacts = "f3NnzQsL";
export var infoBlock = "qggUeQcu";
export var infoTitle = "_96Oc17Ir";
export var telTitle = "_1BQM9xNv";
export var telNumber = "WKH-WGqT";